import { SearchObject } from "app/common/Model/SearchObject";
import { exportAccountsCheckin, exportAccountsDebt } from "app/services/InvoiceItemService";
import { pagingAppointmentReport, pagingpagingVisitReport, reportCheckin } from "app/services/ReportService";
import { exportExcelCheckInReport } from "app/services/VisitService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportCheckinStore {
  listDataCheckin = null;
  searchReportCheckin = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentId: null,
    staffId: null
  }
  searchReportPopupCheckin = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    isReport: true,
    departmentId: null,
  }
  openPopupReportCheckin = false
  listDataPopup = null
  tabPopupReportCheckin = 0;

  openPopupAppointment = false
  listDataPopupAppointment = null
  tabPopupReportAppointment = 0;
  constructor() {
    makeAutoObservable(this);
  }

  handleOpenPopupReportAppointment = async (tab = 0, departmentId = null, searchObj) => {
    this.tabPopupReportAppointment = tab;
    const search = {
      ...this.searchReportPopupCheckin,
      departmentId: departmentId,
      tab: tab,
      fromDate: searchObj?.fromDate,
      toDate: searchObj?.toDate
    };
    return await pagingAppointmentReport(search)
      .then(({ data }) => {
        this.listDataPopupAppointment = data;
        this.openPopupAppointment = true
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu báo cáo có lỗi");
      });
  };

  handleClosePopupReportAppointment = () => {
    this.openPopupAppointment = false
  }

  handleOpenPopupReportCheckin = async (tab = 0, departmentId = null, searchObj) => {
    this.tabPopupReportCheckin = tab;

    const search = {
      ...this.searchReportPopupCheckin,
      departmentId: departmentId,
      tab: tab,
      fromDate: searchObj?.fromDate,
      toDate: searchObj?.toDate
    };

    return await pagingpagingVisitReport(search)
      .then(({ data }) => {
        this.listDataPopup = data;
        this.openPopupReportCheckin = true;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };


  handleClosePopupReportCheckin = () => {
    this.openPopupReportCheckin = false
  }

  handleChangeFormSearchCheckin = (searchReportCheckin) => {
    this.searchReportCheckin = {
      ...this.searchReportCheckin,
      ...searchReportCheckin,
    };
    this.pagingReportCheckin();
  }

  pagingReportCheckin = async () => {
    let { departmentId, staffId, ...ortherData } = this.searchReportCheckin;
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    return await reportCheckin({ ...ortherData })
      .then(({ data }) => {
        this.listDataCheckin = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleExportVisitCheckin = async (searchObj) => {
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportExcelCheckInReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_CHECKIN.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const { departmentId, ...rest } = rawSearch;
    return {
      ...rest,
      departmentId: departmentId?.id || null,
    };
  };

  resetStore = () => {
    this.listData = null
    this.searchFee = { ...new SearchObject(), fromDate: new Date(), toDate: new Date() }

  }
}